import type { MouseEventHandler, ReactNode } from 'react';

export type ButtonVariant = 'act' | 'go' | 'danger' | 'hero';

/**
 * The tracked-caps button (`.btn`, styles/buttons.css): `act` the ordinary
 * outlined action, `go` the filled one a form or decision commits with, `danger`
 * the brick one that deletes, `hero` the page's one add button. `tiny` is the
 * small cut that sits in a row.
 */
export function Button({
  variant,
  tiny = false,
  disabled,
  onClick,
  title,
  children,
}: {
  variant: ButtonVariant;
  tiny?: boolean;
  disabled?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  title?: string;
  children: ReactNode;
}) {
  const className = ['btn', variant, tiny ? 'tiny' : null].filter(Boolean).join(' ');
  return (
    <button type="button" className={className} disabled={disabled} onClick={onClick} title={title}>
      {children}
    </button>
  );
}

/**
 * The destructive action on a page: quiet brick text, last in its footer row
 * (`.danger-link`, styles/buttons.css). The weight is in the confirmation it
 * opens, where the confirm is the filled `danger` Button.
 */
export function DangerLink({
  disabled,
  onClick,
  children,
}: {
  disabled?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
}) {
  return (
    <button type="button" className="danger-link" disabled={disabled} onClick={onClick}>
      {children}
    </button>
  );
}
